export interface Category {
  type: string;
  name: string;
  tagline: string;
  desc: string;
  icon: string;
  image: string;
}

export interface Anime {
  id: string;
  title: string;
  category: string;
  tags: string[];
  rating: number;
  year: number;
  episodes: string;
  status: "连载中" | "已完结";
  updateInfo: string;
  views: string;
  description: string;
  image: string;
}

export interface Special {
  id: string;
  title: string;
  desc: string;
  tag: string;
  image: string;
  count: string;
}

export interface UpdateItem {
  title: string;
  ep: string;
  time: string;
  category: string;
}

export const categories: Category[] = [
  {
    type: "fairy",
    name: "妖精番剧",
    tagline: "奇幻精灵 · 魔法冒险",
    desc: "妖精、精灵与魔法共舞的奇幻故事，热血冒险与治愈陪伴并存。",
    icon: "ri-sparkling-2-fill",
    image: "https://readdy.ai/api/search-image?query=anime%20fantasy%20fairy%20forest%20with%20glowing%20magical%20sparkles%20and%20tiny%20winged%20spirits%20floating%20among%20luminous%20trees%2C%20warm%20coral%20and%20pink%20palette%2C%20soft%20dreamy%20light%2C%20anime%20style%20background%20illustration&width=800&height=600&seq=cat-fairy&orientation=landscape",
  },
  {
    type: "elf",
    name: "精灵动漫",
    tagline: "可爱精灵 · 收集进化",
    desc: "各式各样的小精灵与伙伴同行，收集、进化、并肩战斗的欢乐日常。",
    icon: "ri-gamepad-line",
    image: "https://readdy.ai/api/search-image?query=adorable%20cute%20anime%20elf%20creatures%20with%20big%20eyes%20gathered%20in%20a%20bright%20meadow%2C%20playful%20pastel%20green%20and%20teal%20palette%2C%20cheerful%20sunny%20day%2C%20anime%20style%20background%20illustration&width=800&height=600&seq=cat-elf&orientation=landscape",
  },
  {
    type: "monster",
    name: "妖怪动漫",
    tagline: "妖异百态 · 鬼魅温情",
    desc: "妖怪与人相会的故事，有惊悚怪谈也有温暖羁绊，题材包罗万象。",
    icon: "ri-ghost-2-line",
    image: "https://readdy.ai/api/search-image?query=mysterious%20anime%20youkai%20spirits%20in%20a%20misty%20moonlit%20night%20shrine%20forest%2C%20paper%20lanterns%20and%20floating%20ghosts%2C%20moody%20deep%20teal%20and%20warm%20amber%20palette%2C%20anime%20style%20background%20illustration&width=800&height=600&seq=cat-monster&orientation=landscape",
  },
];

export const animeList: Anime[] = [
  {
    id: "fairy-tail",
    title: "妖精的尾巴",
    category: "fairy",
    tags: ["热血", "魔法", "冒险", "友情"],
    rating: 9.1,
    year: 2009,
    episodes: "全328话",
    status: "已完结",
    updateInfo: "全系列可在线追看",
    views: "2.4亿",
    description:
      "魔导士公会“妖精的尾巴”聚集着一群热血又吵闹的伙伴。拥有强大灭龙魔法的纳兹与伙伴们共同接受委托、迎战强敌，在一次次冒险中守护家园与友情。是奇幻番剧中的经典热血代表。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20determined%20fire%20dragon%20slayer%20boy%20with%20orange%20hair%20and%20a%20blue%20fairy%20mark%20emblem%2C%20fiery%20magic%20flames%20around%20him%2C%20guild%20of%20magic%20wizards%2C%20warm%20coral%20and%20blue%20palette%2C%20epic%20fantasy%20anime%20key%20visual&width=600&height=800&seq=anime-fairytail&orientation=portrait",
  },
  {
    id: "fox-matchmaker",
    title: "狐妖小红娘",
    category: "fairy",
    tags: ["治愈", "古风", "妖怪", "恋爱"],
    rating: 8.9,
    year: 2015,
    episodes: "更新至第12季",
    status: "连载中",
    updateInfo: "每周五更新",
    views: "1.9亿",
    description:
      "在人与妖共存的世间，涂山狐妖一族以红线仙的身份为妖怪与人类牵线续缘。穿越千年的人妖之恋，在欢笑与泪水间展开，是国产妖怪题材奇幻番剧的代表作品。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20beautiful%20fox%20spirit%20girl%20in%20traditional%20chinese%20red%20dress%20with%20nine%20fox%20tails%20and%20a%20red%20ribbon%2C%20peach%20blossoms%20and%20clouds%2C%20warm%20coral%20and%20gold%20palette%2C%20fantasy%20anime%20key%20visual&width=600&height=800&seq=anime-foxmatch&orientation=portrait",
  },
  {
    id: "hotarubi",
    title: "萤火之森",
    category: "fairy",
    tags: ["治愈", "奇幻", "剧场版", "催泪"],
    rating: 9.0,
    year: 2011,
    episodes: "剧场版 45分钟",
    status: "已完结",
    updateInfo: "剧场版可在线观看",
    views: "8600万",
    description:
      "森林中居住着不能触碰人类的妖怪少年阿银，女孩萤每年夏天与他相遇。一场注定不能触碰的恋爱，在萤火与森林间静静生长，直到夏天结束的那一天。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20mysterious%20spirit%20boy%20wearing%20a%20mask%20in%20a%20lush%20green%20forest%20with%20glowing%20fireflies%2C%20soft%20moonlight%2C%20gentle%20melancholy%20atmosphere%2C%20teal%20and%20gold%20palette%2C%20poetic%20anime%20key%20visual&width=600&height=800&seq=anime-hotarubi&orientation=portrait",
  },
  {
    id: "pokemon",
    title: "精灵宝可梦",
    category: "elf",
    tags: ["冒险", "收集", "进化", "童年"],
    rating: 9.2,
    year: 1997,
    episodes: "全1200+话",
    status: "连载中",
    updateInfo: "新篇章连载中",
    views: "5.6亿",
    description:
      "少年小智与皮卡丘踏上成为宝可梦大师的旅程，沿途遇见各式各样的小精灵，收集徽章、挑战道馆、收获友谊。跨越二十多年的经典精灵动漫，陪伴了几代人的成长。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20cheerful%20boy%20trainer%20with%20a%20yellow%20electric%20mouse%20creature%20on%20his%20shoulder%2C%20catching%20wild%20creatures%20in%20a%20bright%20meadow%2C%20playful%20yellow%20and%20teal%20palette%2C%20adventurous%20anime%20key%20visual&width=600&height=800&seq=anime-pokemon&orientation=portrait",
  },
  {
    id: "spirited-away",
    title: "千与千寻",
    category: "elf",
    tags: ["治愈", "奇幻", "剧场版", "宫崎骏"],
    rating: 9.4,
    year: 2001,
    episodes: "剧场版 125分钟",
    status: "已完结",
    updateInfo: "剧场版可在线观看",
    views: "3.2亿",
    description:
      "少女千寻误入神灵与妖怪居住的奇妙世界，父母被变成猪，她必须在油屋中工作并寻找回家的路。在神隐的奇幻世界里，千寻学会勇敢与善良，找回自己的名字。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20young%20girl%20in%20red%20kimono%20walking%20toward%20a%20mysterious%20bathhouse%20at%20dusk%2C%20glowing%20spirit%20world%2C%20magical%20teal%20and%20coral%20palette%2C%20enchanting%20ghibli%20style%20anime%20key%20visual&width=600&height=800&seq=anime-chihiro&orientation=portrait",
  },
  {
    id: "elf-luoli",
    title: "精灵梦叶罗丽",
    category: "elf",
    tags: ["魔法", "变身", "少女", "奇幻"],
    rating: 7.8,
    year: 2013,
    episodes: "更新至第11季",
    status: "连载中",
    updateInfo: "每周四更新",
    views: "1.1亿",
    description:
      "少女王默偶然遇到拥有魔法力量的叶罗丽精灵，缔结契约获得变身能力。在人类世界与精灵世界之间，少女们与精灵伙伴共同守护平衡，展开充满魔法的冒险。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20magical%20girl%20with%20pink%20flowing%20hair%20and%20sparkly%20transformation%20dress%2C%20surrounded%20by%20cute%20fairy%20spirit%20companions%20and%20sparkles%2C%20vibrant%20pink%20and%20coral%20palette%2C%20magical%20girl%20anime%20key%20visual&width=600&height=800&seq=anime-luoli&orientation=portrait",
  },
  {
    id: "horizon",
    title: "宝可梦 地平线",
    category: "elf",
    tags: ["冒险", "新篇", "收集", "友情"],
    rating: 8.7,
    year: 2023,
    episodes: "更新至第68话",
    status: "连载中",
    updateInfo: "每周六更新",
    views: "1.4亿",
    description:
      "宝可梦系列全新篇章，主角不再是小智，而是少女莉可与新伙伴踏上横跨地平线的冒险。更成熟的叙事与全新的角色组合，让经典精灵动漫焕发新生。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20brave%20girl%20with%20a%20blue%20pendant%20and%20a%20small%20green%20dragon%20companion%2C%20adventuring%20across%20a%20sunset%20horizon%20with%20wild%20creatures%2C%20warm%20teal%20and%20coral%20palette%2C%20anime%20key%20visual&width=600&height=800&seq=anime-horizon&orientation=portrait",
  },
  {
    id: "natsume",
    title: "夏目友人帐",
    category: "monster",
    tags: ["治愈", "妖怪", "日常", "温情"],
    rating: 9.3,
    year: 2008,
    episodes: "全7季+剧场版",
    status: "连载中",
    updateInfo: "第七季更新中",
    views: "2.1亿",
    description:
      "能看见妖怪的少年夏目贵志继承祖母的“友人帐”，在归还妖怪名字的过程中结识妖怪与人类伙伴。一个个温柔的故事在人与妖之间展开，是妖怪题材最治愈的代表作。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20gentle%20boy%20with%20warm%20brown%20hair%20and%20a%20round%20lucky%20cat%20spirit%20beside%20him%2C%20meadow%20and%20summer%20light%2C%20soft%20green%20and%20amber%20palette%2C%20heartwarming%20anime%20key%20visual&width=600&height=800&seq=anime-natsume&orientation=portrait",
  },
  {
    id: "kamigami",
    title: "元气少女缘结神",
    category: "monster",
    tags: ["恋爱", "妖怪", "神明", "治愈"],
    rating: 8.8,
    year: 2012,
    episodes: "全2季+OVA",
    status: "已完结",
    updateInfo: "全系列可在线追看",
    views: "9800万",
    description:
      "无家可归的少女奈奈生意外成为土地神，遇见狐妖神使巴卫。在神明与妖怪的世界里，两人的缘分渐渐加深，展开一段跨越百年的恋爱故事。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20cheerful%20girl%20shrine%20deity%20with%20a%20proud%20silver%20fox%20spirit%20with%20red%20markings%2C%20cute%20romantic%20anime%20style%2C%20pink%20and%20coral%20palette%2C%20fantasy%20anime%20key%20visual&width=600&height=800&seq=anime-kamigami&orientation=portrait",
  },
  {
    id: "yokai-watch",
    title: "妖怪手表",
    category: "monster",
    tags: ["搞笑", "妖怪", "日常", "童年"],
    rating: 8.2,
    year: 2014,
    episodes: "全200+话",
    status: "已完结",
    updateInfo: "全系列可在线追看",
    views: "1.6亿",
    description:
      "少年天野景太捡到妖怪手表，从此能看见形形色色的妖怪，并与他们并肩解决日常中的怪事。轻松搞笑的日常妖怪故事，深受孩子和家庭喜爱。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20boy%20with%20a%20magical%20wrist%20watch%20summoning%20a%20silly%20friendly%20little%20ghost%20creature%2C%20funny%20everyday%20background%2C%20bright%20teal%20and%20yellow%20palette%2C%20comedy%20anime%20key%20visual&width=600&height=800&seq=anime-yokaiwatch&orientation=portrait",
  },
  {
    id: "inuyasha",
    title: "犬夜叉",
    category: "monster",
    tags: ["冒险", "妖怪", "战国", "热血"],
    rating: 9.0,
    year: 2000,
    episodes: "全193话+完结篇",
    status: "已完结",
    updateInfo: "全系列可在线追看",
    views: "2.7亿",
    description:
      "现代少女戈薇通过食骨之井穿越到战国时代，遇见半妖少年犬夜叉。为集齐四魂之玉碎片，两人与伙伴们踏上冒险之旅，对抗妖怪与宿敌奈落。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20half%20demon%20boy%20with%20silver%20hair%20and%20dog%20ears%20holding%20a%20cursed%20sword%2C%20across%20ancient%20japan%20battlefield%20with%20glowing%20fragment%20of%20the%20sacred%20jewel%2C%20moody%20purple%20and%20coral%20palette%2C%20epic%20anime%20key%20visual&width=600&height=800&seq=anime-inuyasha&orientation=portrait",
  },
  {
    id: "kakuriyo",
    title: "妖怪旅馆营业中",
    category: "monster",
    tags: ["日常", "妖怪", "美食", "治愈"],
    rating: 8.4,
    year: 2018,
    episodes: "全26话",
    status: "已完结",
    updateInfo: "全系列可在线追看",
    views: "7300万",
    description:
      "能看见妖怪的少女葵被带到妖怪栖息的温泉旅馆，欠下债务的她凭一手料理手艺在旅馆打工还债。在妖怪与美食交织的日常里，葵逐渐找到自己的位置。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20cheerful%20girl%20chef%20with%20an%20apron%20standing%20before%20a%20warm%20traditional%20youkai%20hot%20spring%20inn%2C%20glowing%20lanterns%20and%20gentle%20spirits%2C%20warm%20amber%20and%20teal%20palette%2C%20cozy%20anime%20key%20visual&width=600&height=800&seq=anime-kakuriyo&orientation=portrait",
  },
  {
    id: "mononoke",
    title: "幽灵公主",
    category: "monster",
    tags: ["剧场版", "自然", "妖怪", "宫崎骏"],
    rating: 9.3,
    year: 1997,
    episodes: "剧场版 133分钟",
    status: "已完结",
    updateInfo: "剧场版可在线观看",
    views: "2.0亿",
    description:
      "被诅咒的少年阿席达卡为解除诅咒踏上旅程，在人与森林妖怪的冲突之间，遇见了由狼神养大的少女小桑。关于自然、文明与共存的宏大奇幻故事。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20young%20warrior%20boy%20with%20a%20red%20mask%20mark%20riding%20with%20a%20wolf%20spirit%20girl%20in%20a%20dense%20ancient%20forest%2C%20mystical%20creatures%2C%20deep%20green%20and%20coral%20palette%2C%20epic%20ghibli%20style%20anime%20key%20visual&width=600&height=800&seq=anime-mononoke&orientation=portrait",
  },
  {
    id: "folktales",
    title: "物语系列",
    category: "monster",
    tags: ["怪谈", "心理", "妖怪", "文艺"],
    rating: 9.1,
    year: 2009,
    episodes: "全系列+剧场版",
    status: "连载中",
    updateInfo: "剧场版制作中",
    views: "1.2亿",
    description:
      "高中少年阿良良木历接连遇见被妖怪附身的少女们。怪异、情感与孤独交织，以独特的对白与视角展开一个个关于“怪”与“人”的故事。",
    image: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20mysterious%20girl%20with%20long%20hair%20standing%20in%20a%20dim%20corridor%20with%20floating%20ghostly%20crab%20spirit%20shadows%2C%20artsy%20moody%20lighting%2C%20deep%20teal%20and%20pink%20palette%2C%20stylish%20anime%20key%20visual&width=600&height=800&seq=anime-monogatari&orientation=portrait",
  },
];

export const specials: Special[] = [
  {
    id: "fairy-tall-spirits",
    title: "百年情缘 · 妖精与狐仙",
    desc: "盘点那些跨越百年的妖精恋爱故事，看人与妖精如何跨越寿命与种族相守。",
    tag: "专题策划",
    image: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20fox%20spirit%20and%20a%20human%20stargazing%20under%20a%20peach%20blossom%20tree%20at%20night%2C%20warm%20romantic%20glow%20and%20floating%20sparkles%2C%20coral%20and%20gold%20palette%2C%20dreamy%20fantasy%20anime%20illustration&width=800&height=520&seq=special-love&orientation=landscape",
    count: "8 部",
  },
  {
    id: "yokai-heal",
    title: "妖怪也能很温柔",
    desc: "妖怪不只有可怕传说，更有许多治愈系妖怪番剧温暖人心。",
    tag: "治愈合辑",
    image: "https://readdy.ai/api/search-image?query=gentle%20anime%20illustration%20of%20cute%20friendly%20youkai%20spirits%20sitting%20together%20on%20a%20summer%20porch%20with%20warm%20tea%20and%20fireflies%2C%20soft%20green%20and%20amber%20palette%2C%20cozy%20heartwarming%20atmosphere&width=800&height=520&seq=special-heal&orientation=landscape",
    count: "6 部",
  },
  {
    id: "new-era-elf",
    title: "精灵世界新冒险",
    desc: "从经典到新章，见证精灵宝可梦一路走来的冒险与成长。",
    tag: "系列盘点",
    image: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20group%20of%20adventuring%20trainers%20with%20colorful%20elf%20creatures%20crossing%20a%20bright%20rainbow%20bridge%20over%20a%20sparkling%20ocean%2C%20teal%20and%20yellow%20palette%2C%20energetic%20fantasy%20anime%20illustration&width=800&height=520&seq=special-newelf&orientation=landscape",
    count: "5 部",
  },
];

export const updates: UpdateItem[] = [
  { title: "狐妖小红娘", ep: "第12季 第18话", time: "今天 20:00", category: "fairy" },
  { title: "宝可梦 地平线", ep: "第68话", time: "昨天 18:30", category: "elf" },
  { title: "夏目友人帐", ep: "第七季 第5话", time: "昨天 21:00", category: "monster" },
  { title: "精灵梦叶罗丽", ep: "第11季 第10话", time: "昨天 19:00", category: "elf" },
  { title: "物语系列", ep: "新剧场版预告", time: "3天前", category: "monster" },
];

export const faqs = [
  {
    q: "妖精动漫网的番剧题材是怎样分类的？",
    a: "本站将奇幻番剧集中整理为三大题材：妖精番剧（妖精、精灵、魔法冒险）、精灵动漫（可爱小精灵、收集进化）、妖怪动漫（妖怪、神明、怪谈与怪谈治愈）。每个分类下有对应的番剧卡片与详情入口，方便按题材直接查找。",
  },
  {
    q: "如何快速找到某部想看的奇幻番剧？",
    a: "你可以在首页顶部的搜索框直接输入番剧名称，也可以按题材分类进入对应栏目，再根据“热门”“最新”“已完结”等标签筛选。每部番剧卡片都带有评分、年份、更新状态等信息，帮助快速判断。",
  },
  {
    q: "番剧的更新信息准不准确？",
    a: "“最新追更”板块会汇总各番剧的最新一话与更新时间，供追更参考。由于版权与上线平台各有差异，具体播放请以各正版平台的实际上线情况为准，本站仅做题材整理与推荐。",
  },
  {
    q: "这里会收录冷门妖怪系作品吗？",
    a: "会的。除了妖精的尾巴、精灵宝可梦、夏目友人帐等热门作品，我们也会持续补充相对冷门但值得一看的妖怪、妖精题材番剧，帮助喜欢奇幻题材的用户发现更多好作品。",
  },
  {
    q: "我可以投稿推荐某部番剧吗？",
    a: "可以。如果你有想推荐的妖精、精灵或妖怪题材番剧，欢迎通过“联系我们”页面留言告诉我们，我们会审核后将其补充进对应的题材分类中。",
  },
];